import React, { Component } from "react"
import { connect } from "react-redux"
import { Popover, PopoverBody } from "reactstrap"

import BackgroundImage from "./common/BackgroundImage"
import { unauthenticated } from "../actions/authentication-actions"

import { images } from "../config/image-definitions"
const { peoplePlaceholder } = images

class UserMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPopoverOpen: false
        }
        this.togglePopover = this.togglePopover.bind(this)
        this.logout = this.logout.bind(this)
    }

    togglePopover() {
        this.setState({
            isPopoverOpen: !this.state.isPopoverOpen
        })
    }

    logout() {
        this.togglePopover()
        this.props.logout()
    }

    render() {
        return (
            <div id="logout">
                <a className="logout-content" role="button" tabIndex="0">
                    <BackgroundImage
                        classList={["icon-user"]}
                        imageUrl={this.props.photoUrl}
                        defaultImageUrl={peoplePlaceholder}
                        onClick={this.togglePopover}
                    />
                    <Popover
                        placement="left"
                        isOpen={this.state.isPopoverOpen}
                        target="logout"
                        toggle={this.togglePopover}
                        trigger="legacy"
                    >
                        <PopoverBody>
                            <ul
                                className="list-group"
                                aria-labelledby="user-icon"
                            >
                                <li
                                    className="list-group-item"
                                    onClick={this.logout}
                                >
                                    <i className="fa fa-sign-out" />
                                    &nbsp;Logout
                                </li>
                            </ul>
                        </PopoverBody>
                    </Popover>
                </a>
            </div>
        )
    }
}

const mapStateToProps = ({ authentication }) => ({
    photoUrl: authentication.photo_url
})

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(unauthenticated(true))
})

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)
